import { types } from 'mobx-state-tree';

const model = {
  id: types.string,
  color: types.string,
  name: types.string,
};

const actions = () => ({});
const views = () => ({});

const TagModel = types
  .model(model)
  .actions(actions)
  .views(views);

export default TagModel;
